<template>
  <div>
    <strong>Sage configuration</strong>
    <br/><br/>

      <table>
        <thead>
          <tr>
            <td><strong>Name</strong></td>
            <td><strong>Endpoint</strong></td>
            <td><strong>Environment</strong></td>
            <td><strong>Action</strong></td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="endpoint in endpoints">
            <td>{{ endpoint.NAME }}</td>
            <td>{{ endpoint.ENDPOINT }}</td>
            <td>
              <div class="select">
                  <select v-model="endpoint.ENV">
                    <option v-for="env in endpoint.AVAILABLE_ENVS" :key="env">{{env}}</option>
                  </select>
              </div>
            </td>
            <td><a @click="update_env(endpoint.NAME)" class="button is-warning"><span class="icon"><i class="fa fa-save"></i></span><span>Update</span></a></td>
          </tr>
        </tbody>
      </table>

  </div>
</template>

<script>
import auth from '../auth'
import axios from 'axios'

export default {
  name: 'SageConfig',
  data () {
    return {
      endpoints: []
    }
  },
  methods: {
    fetch_environments () {
      axios.get('/api/get_available_sage_environments').then(response => {
        this.endpoints = response.data.environments
      })
    },
    update_env (envName) {
      axios.post('/api/set_sage_environment', {
        environment: this.endpoints[envName].ENV,
        name: envName
      }).then(response => {
        this.$root.open_message_modal('Environment updated!')
      })
    }
  },
  created () {
    auth.checkAuth(['config_sage'])
    this.fetch_environments()
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
table {
  display: inline-block;
}

th, td {
  border-bottom: 1px solid #ddd;
  padding: 15px;
}

</style>
